import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { createBrowserHistory as history } from "history";
import Login from "./components/Login";
import AdminWrapper from "./containers/AdminWrapper";
import "react-toastify/dist/ReactToastify.css";
import EmployeeWrapper from "./containers/EmployeeWrapper";
import PrivateRoute from "./components/PrivateRoute";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AuthGuard from "./context/Auth/AuthGuard";
import { TenantProvider } from "./context/Tenant/TenantContext";
import TenantOnboarding from "./containers/TenantOnboarding";
import Docs from "./containers/Docs";
import { isTokenExpired } from "./utils/isTokenExpired";
import instance from "./api/api";

export default function App() {
  
  useEffect(() => {
    const checkAndRefreshToken = async () => {
      // Skip token refresh if already on the login page
      if (window.location.pathname === "/login" || window.location.pathname !== "/forgot-password" || window.location.pathname !== "/reset-password") {
        return;
      }
      const accessToken = localStorage.getItem("token");
  
      // Check if the token is expired
      if (!accessToken || isTokenExpired(accessToken)) {
        console.log("Token expired, refreshing...");
        try {
          // Call the refresh token API
          const response = await instance.post(
            "/api/auth/refresh-token",
            {},
            {
              withCredentials: true, // 👈 REQUIRED for cookies to be sent
            }
          );
          const newAccessToken = response.data.accessToken;
  
          // Save the new token in localStorage
          localStorage.setItem("token", newAccessToken);
          console.log("Token refreshed successfully")
        } catch (error) {
          console.error("Failed to refresh token:", error);
          localStorage.removeItem("token");
  
          // If refreshing fails, redirect to login only once
          if (window.location.pathname !== "/login") {
            window.location.href = "/login";
          }
        }
      }
    };
  
    checkAndRefreshToken();
  }, []);

  return (
    <TenantProvider>
      <Router history={history}>
        <AuthGuard>
          <Routes>
            <Route exact path="/" element={<Login />}></Route>
            <Route exact path="/login" element={<Login />}></Route>
            <Route
              exact
              path="/forgot-password"
              element={<ForgotPassword />}
            ></Route>
            <Route
              exact
              path="/reset-password"
              element={<ResetPassword />}
            ></Route>
            <Route
              path="/admin/*"
              element={
                <PrivateRoute requiredRole="ADMIN" redirectPath="/">
                  <AdminWrapper />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/employee/*"
              element={
                <PrivateRoute requiredRole="EMPLOYEE" redirectPath="/">
                  <EmployeeWrapper />
                </PrivateRoute>
              }
            ></Route>
            <Route path="/superadmin/onboard-tenant" element={<TenantOnboarding />} />
            <Route path="/docs" element={<Docs />} />
          </Routes>
        </AuthGuard>
      </Router>
    </TenantProvider>
  );
}
